export default __webpack_public_path__ + "static/media/doc-logo.aa3219d6.png";